import { render } from "./CustomInput.vue?vue&type=template&id=93183e5a"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__